<template>
    <div style="height:100%;padding:4px;">
        <div @click.stop style="position: static; width:100%;height:100%; margin:0 auto;overflow-y:auto;">
            <div
                style=" position:-webkit-sticky; position: sticky;top:0px;background: white; padding: 4px; margin-bottom: 8px; border-radius: 6px; max-width: 800px; margin: 0 auto; display: flex; justify-content: center; align-items: center;z-index: 10;">
                <div class="btn-group" role="group" style="display: flex; width: 100%;">
                    <input type="text" class="btn btn-default"
                        :placeholder="lang.common.keyword + ' ' + lang.common.search" v-model="keyword"
                        style="flex: 1; min-width: 0; text-align: left; border-radius: 4px 0 0 4px;">
                    <button type="button" class="btn btn-default agx-theme-bg" style="width: 80px; padding: 0;"
                        @click="searchClick">{{ lang.common.search
                        }}</button>
                    <button type="button" class="btn btn-default" style="width: 50px; padding: 0;font-weight:bolder;"
                        @click="showAll">X</button>
                    <div class="btn-group" role="group" style="width: 40px;">
                        <button type="button" class="btn btn-default dropdown-toggle agx-theme-bg"
                            data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
                            style="width: 40px;height: 40px; padding: 0;" @click="filterSetHide(!showKeyOnly)"><span
                                class="caret"></span></button>
                    </div>
                </div>
            </div>


            <template v-if="showLevelOneMenu">
                <div style="display: flex;width:100%;flex-direction: row;overflow-y: auto;border-bottom:1px solid gray;border-top:1px solid gray;background: white;"
                    v-on:click="onCatDirectSelect(null, -1)">
                    <div style="padding:1px;min-width: 200px;margin:0 auto;flex:0 0 auto;text-align: center;"
                        v-on:click.stop :class="{ 'agx-theme-bg': currentIndex === index }"
                        v-for="(levelOne, index) in levelOneCats">
                        <category-tree :showCheckbox="false" :show-node="true" :expand-child="false"
                            :cat-node="levelOne" :expand-all="false" :viewMode="{}" :showExpandSign="false"
                            v-on:catSelected="val => onLevelOneCatSelected(val, index)"
                            v-on:expandClick="val => { console.log('expandClick'); }"></category-tree>
                    </div>
                </div>
                <!-- <template v-if="levelTwoNodes !== null">
                    <div style="width: 100%;height: 4px;" class="agx-theme-bg"></div>
                    <div style="width: 100%;display: flex;flex-wrap: wrap; justify-content: center;background-color: rgba(128, 128, 128, 0.5);"
                        v-on:click="() => { levelTwoNodes = null; }">
                        <div v-for="(cat, index) in levelTwoNodes"
                            style="border-left:1px solid gray;border-right:1px solid gray;padding:4px;background:white;"
                            v-on:click.stop>
                            <category-tree :showCheckbox="false" :showExpandSign="false" :show-node="true"
                                :expand-child="true" :cat-node="cat" :expand-all="true"
                                :viewMode="{ nameClass: cat.childs.length > 0 ? '' : 'btn btn-default' }"
                                v-on:catSelected="val => onCatDirectSelect(val, index)"
                                v-on:expandClick="val => onCatDirectSelect(val, index)"></category-tree>
                        </div>
                    </div>
                </template> -->
            </template>

            <div v-if="filterInfo !== null && !showKeyOnly"
                style="max-width: 700px;margin:0 auto;margin-bottom: 20px;padding-bottom:10px;outline: none;border-color: #9ecaed;box-shadow: 0 0 10px #9ecaed;background: white;">

                <div style="background: white; border-radius: 6px;border-top:1px solid gray;">
                    <div style="display: flex;">
                        <div>
                            <span class="btn btn-default" @click="sortChange(sorting.field)">
                                <span class="glyphicon glyphicon-arrow-up"
                                    :style="{ color: sorting.isAsc ? 'green' : '' }"></span>
                                {{ lang.common.sorting }}
                                <span class="glyphicon glyphicon-arrow-down"
                                    :style="{ color: sorting.isAsc ? '' : 'green' }"></span>
                            </span>
                        </div>
                        <div style="flex: 1;">
                            <select style="text-align: center;" class="form-control" v-model="sorting.field"
                                v-on:change="() => { hasChange = true; }">
                                <option value="date">{{ lang.common.date }}</option>
                                <option value="price">{{ lang.common.price }}</option>
                            </select>
                        </div>
                    </div>
                </div>

                <div v-if="filterInfo.itemTagCatNode !== null && filterInfo.itemTagCatNode.childs.length > 0"
                    class="agx-filter-cats" style="background: white; border-radius: 6px;border-top:1px solid gray;">
                    <span class="agx-parent-cat agx-theme-bg form-control"><span
                            class="glyphicon glyphicon-filter"></span>
                        {{ lang.common.tags }}</span>
                    <div>
                        <category-tree :show-node="false" :expand-child="true" :cat-node="filterInfo.itemTagCatNode"
                            v-on:catSelected="onTagTreeNodeSelected" :selected="{ ...tagSelection }" :expand-all="true"
                            :viewMode="{}"></category-tree>
                    </div>
                </div>

                <div v-if="filterInfo.listingCatNode !== null && filterInfo.listingCatNode.childs.length > 0"
                    class="agx-filter-cats" style="background: white; border-radius: 6px;border-top:1px solid gray;">
                    <span class="agx-parent-cat agx-theme-bg form-control"><span
                            class="glyphicon glyphicon-filter"></span>
                        {{ lang.common.categories }}</span>
                    <div>
                        <category-tree :hide-zero-counts="true" :show-node="false" :expand-child="true" :cat-node="filterInfo.listingCatNode"
                            :expand-all="true" :viewMode="{}" v-on:catSelected="onCatTreeNodeSelected"
                            :selected="{ ...catSelection }"></category-tree>
                    </div>
                </div>

                <div
                    style="background: white; padding: 4px; margin-bottom: 8px; border-radius: 6px; max-width: 800px; margin: 0 auto; display: flex; justify-content: center; align-items: center;">
                    <div class="btn-group" role="group" style="display: flex; width: 100%;">
                        <input type="text" class="btn btn-default"
                            :placeholder="lang.common.keyword + ' ' + lang.common.search" v-model="keyword"
                            style="flex: 1; min-width: 0; text-align: left; border-radius: 4px 0 0 4px;">
                        <button type="button" class="btn btn-default agx-theme-bg" style="width: 80px; padding: 0;"
                            @click="searchClick">{{
                            lang.common.search
                        }}</button>
                        <button type="button" class="btn btn-default"
                            style="width: 50px; padding: 0;font-weight:bolder;" @click="showAll">X</button>
                        <div class="btn-group" role="group" style="width: 40px;">
                            <button type="button" class="btn btn-default dropdown-toggle" data-toggle="dropdown"
                                aria-haspopup="true" aria-expanded="false" style="width: 40px;height: 40px; padding: 0;"
                                @click="filterSetHide(!showKeyOnly)"><span class="caret"></span></button>
                        </div>
                    </div>
                </div>


            </div>

        </div>
    </div>
</template>

<script>
import CategoryTree from './CategoryTree.vue';

let defaultSorting = { field: "date", isAsc: false };

export default {
    components: {
        CategoryTree: CategoryTree
    },
    props: {
        "filterInfo": { type: Object, default: null },
        "shopCode": { type: String, default: null },
        "listingType": { type: String, default: null },
        "anyChange": { type: Boolean, default: null },
        "showKeyOnly": { type: Boolean, default: false },
        "autoRoute": { type: Boolean, default: true },
        "showLevelOneMenu": { type: Boolean, default: false },
        "langOverride": { type: Object, default: null }
    },
    computed: {
        lang: function () {
            if (this.langOverride !== null) {
                return this.langOverride;
            }
            return this.$store.getters.lang;
        },
        hasLogin: function () {
            return this.$store.getters.account !== null;
        },
        levelOneCats() {
            if (!this.filterInfo.listingCatNode && !this.filterInfo.listingCatNode.childs) {
                return [];
            }
            return this.filterInfo.listingCatNode.childs
        }
    },
    data: function () {
        return {
            showMenu: true,
            keyword: null,
            showCatGroup: null,
            targetList: 'listing',
            targetCats: [],
            catSelection: { catIds: [], timestamp: 0 },
            tagSelection: { catIds: [], timestamp: 0 },
            temps: { tags: [], cats: [] },
            lastRoute: null,
            currentIndex: null,
            levelTwoNodes: null,
            sorting: { field: defaultSorting.field, isAsc: defaultSorting.isAsc },
            hasChange: false,
        }
    },
    methods: {
        goSearch: function (routeObj) {
            this.hasChange = false;
            this.$emit("search", routeObj);
            this.lastRoute = routeObj;
            if (this.autoRoute === true) {
                this.$router.push(routeObj);
            }
        },
        sortChange(fieldName) {
            this.hasChange = true;
            if (this.sorting.field === fieldName) {
                this.sorting.isAsc = !this.sorting.isAsc;
            } else {
                this.sorting.field = fieldName;
            }
        },
        filterSetHide(toHide) {
            this.showKeyOnly = toHide;
            this.loadCriteria();
        },
        emitOnclose() {
            this.$emit("onclose");
        },
        setShow: function (toShow) {
            this.showMenu = toShow;
            this.loadCriteria();
            if (this.showMenu === false) {
                this.emitOnclose();
            }
        },
        toggleMenu: function () {
            this.setShow(!this.showMenu);
        },
        showAll: function () {
            this.setShow(false);
            this.sorting.field = defaultSorting.field;
            this.sorting.isAsc = defaultSorting.isAsc;
            this.goSearch({ name: this.targetList });
        },
        searchClick: function () {
            var obj = { name: this.targetList, query: { keyword: this.keyword, cat: this.temps.cats, tag: this.temps.tags, timestamp: Date.now(), sortBy: this.sorting.field, sort: this.sorting.isAsc ? 'asc' : 'desc' } };
            this.goSearch(obj);
            this.emitOnclose();
        },
        setCatTreeSelection(catIds) {
            this.catSelection.catIds = catIds;
            this.catSelection.timestamp = Date.now();
        },
        setTagTreeSelection(catIds) {
            this.tagSelection.catIds = catIds;
            this.tagSelection.timestamp = Date.now();
        },
        onLevelOneCatSelected(catPair, index) {
            console.log('indexes', this.currentIndex, index);
            var isSameCat = this.currentIndex === index;
            this.currentIndex = isSameCat ? null : index;
            if (isSameCat) {
                this.levelTwoNodes = null;
                return;
            }
            console.log('catPair', catPair, index);
            this.levelTwoNodes = catPair.child.childs;
            
            //
            this.routeToCat(catPair);
            return;

            if (this.levelTwoNodes.length === 0) {
                this.onCatDirectSelect(catPair, index);
            }
        },
        routeToCat(catPair){
            this.$router.push({ name: 'listing', query: { cat: catPair.child.catId } });
        },
        onCatDirectSelect(catPair, index) {
            if (catPair != null && catPair.decendents.length === 0) {
                this.$router.push({ name: 'listing', query: { cat: catPair.child.catId } });
            }
        },
        removeDecendents(decendentCats, currentCatIds) {
            function removeListFromList(list, removeList) {
                var items = list;
                var toKeepItems = items.filter(t => removeList.indexOf(t) < 0);
                return toKeepItems;
            }
            if (decendentCats && decendentCats.length > 0) {
                var decentIds = decendentCats.map(c => c.catId);
                var toKeep = removeListFromList([...currentCatIds], decentIds);
                console.log("toKeep items", toKeep);
                return toKeep;
            }
            return currentCatIds;
        },
        onCatTreeNodeSelected(catPair) {
            this.hasChange = true;
            this.temps.cats = this.removeDecendents(catPair.decendents, this.temps.cats);
            this.onCatSelected({ parent: catPair.parent, cat: catPair.child });
        },
        onTagTreeNodeSelected(catPair) {
            this.hasChange = true;
            this.temps.tags = this.removeDecendents(catPair.decendents, this.temps.tags);
            this.onTagSelected({ parent: catPair.parent, cat: catPair.child });
        },
        onCatSelected: function (catPair) {
            console.log('FilterMenuForm onCatSelected', catPair);
            this.catPair = catPair;
            var id = catPair.cat.catId;
            var cats = this.temps.cats;
            this.temps.cats = this.getArrayObj(cats, id);
            this.setCatTreeSelection([...this.temps.cats]);
        },
        onTagSelected: function (catPair) {
            this.catPair = catPair;
            var id = catPair.cat.catId;
            var tags = this.temps.tags;
            this.temps.tags = this.getArrayObj(tags, id);
            this.setTagTreeSelection([...this.temps.tags]);
        },
        getArrayObj(tags, val) {
            val = val * 1;
            if (tags) {
                if (tags instanceof Array) {
                    tags = tags.map(i => i * 1);
                    var index = tags.indexOf(val);
                    if (index < 0) {
                        tags.push(val * 1);
                    } else {
                        tags.splice(index, 1);
                    }
                } else {
                    if (val == tags) return [];
                }
            } else {
                if (val !== null) {
                    if (val == tags) return [];
                    tags = [val];
                }
            };
            return tags;
        },
        loadCriteria: function () {
            if (this.listingType && this.listingType !== null && this.listingType !== '') {
                this.targetList = this.listingType;
            }

            if (this.targetList === 'listing') {
                this.targetCats = this.filterInfo.listingCats;
            } else {
                this.targetCats = this.filterInfo.articles;
            }

            var cats = [];
            var tags = [];

            var ret = this.loadFromRoute();
            if (ret !== null) {
                cats = ret.cats;
                tags = ret.tags;
            } else {
                if (this.lastRoute !== null) {
                    if (this.lastRoute.query) {
                        ret = this.lastRoute;
                        cats = ret.query.cat;
                        tags = ret.query.tag;
                    }
                }
            }

            this.setTagTreeSelection(tags);
            this.setCatTreeSelection(cats);
            this.temps.cats = cats;
            this.temps.tags = tags;
        },
        loadFromRoute() {
            var routeInfo = this.$route;
            var routeName = routeInfo.name;
            var query = routeInfo.query;
            console.log("loadingCriteria", query);
            //to do, fix not restoring unqueried cats and tags on non targetList page
            if (routeName === this.targetList) {
                this.keyword = query.keyword;
                if (query.sortBy) {
                    this.sorting.field = query.sortBy;
                    this.sorting.isAsc = query.sort === 'asc';
                }
                var tags = [];
                var cats = [];
                if (query.cat) {
                    if (query.cat instanceof Array) {
                        cats = [...query.cat.map(i => i * 1)];
                    } else {
                        cats = [query.cat * 1];
                    }
                }
                if (query.tag) {
                    if (query.tag instanceof Array) {
                        tags = [...query.tag.map(i => i * 1)];
                    } else {
                        tags = [query.tag * 1];
                    }
                }
                return { cats: cats, tags: tags };
            }
            return null;
        },
    },
    created: function () {
        this.loadCriteria();
    },
    watch: {
        anyChange: function () {
            this.loadCriteria();
        },
        '$route': function () {
            console.log('route changed');
            this.loadCriteria();
        }
    }
}
</script>
